import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Toast from './components/Toast'
import "lib-flexible"

Vue.config.productionTip = false
Vue.prototype.$toast = Toast;

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

new Vue({
  router,
  store,
  // vConsole,
  render: h => h(App)
}).$mount("#app");
